import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreContext } from './context/index.js';
import { selectCurrentCurrencyCode } from './storeSelectors/currencies.js';

const AlmaBanner = ({ prices }) => {
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    const { data: { siteConfig: { product: { almaBanner = false } = {} }, }, useSelector, } = useContext(CoreContext);
    if (!almaBanner) {
        return null;
    }
    const currencyCode = useSelector(selectCurrentCurrencyCode);
    const bannerThresholds = {
        // Temporary frontend solution, currency values for alma thresholds should come from the backend
        EUR: 50,
        CHF: 47,
        GBP: 42,
        PLN: 215,
        RON: 249,
        AED: 195,
    };
    const higherPrice = prices.newPrice.includes(' - ')
        ? prices.newPrice.split(' - ')[1].replace(/[^0-9]/g, '')
        : prices.newPrice.replace(/[^0-9]/g, '');
    if (bannerThresholds[currencyCode] > parseFloat(higherPrice)) {
        return null;
    }
    return (React.createElement("div", { className: "product-config-alma-wrapper" },
        React.createElement("div", { className: "product-config-alma" },
            React.createElement("i", { className: "alma-logo" }),
            React.createElement("p", { className: "no-spacing font-body-small" }, tCommon('almaInstallments')))));
};

export { AlmaBanner as A };
//# sourceMappingURL=AlmaBanner-qWjGjPhU.js.map
